import axiosInstance from "../Interceptor"

export const getCustomerCarteApi = (payload) => {
	// console.log(payload);

	return axiosInstance
		.get(`inventory-service/api/v3/cart/`)

		.then((response) => {
			// console.log(response)
			return response
		})
		.catch((error) => {
			// console.log(error);
			return error
		})
}
